import React from "react";

import { ThemeProvider } from "@material-ui/core/styles";
import theme from "../theme";
import { CssBaseline } from "@material-ui/core";

import * as firebase from "firebase/app";
import "firebase/analytics";
import AppLayout from "./AppLayout";

interface Props {}
interface State {}

class App extends React.Component<Props, State> {
  async componentDidMount(): Promise<void> {
    const response = await fetch("/__/firebase/init.json");
    firebase.initializeApp(await response.json());
    firebase.analytics();
  }

  render() {
    return (
      <div>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AppLayout />
        </ThemeProvider>
      </div>
    );
  }
}

export default App;
